<template>
   <div class="careers content-wrapper">
      <div class="landing-box text-white">
         <div class="header-box container container-1200">
            <div class="row justify-content-center">
               <div class="col-10 landing-box-data text-center">
                  <h1 class="text-white">{{ landingBoxData.header }}</h1>
                  <p>{{ descriptionJoiner(landingBoxData.shortDescription) }}</p>
                  <div class="action-box text-center mt-3">
                     <span v-for="(cta, index) in landingBoxData.ctas" :key="index">
                        <a
                           :href="cta.link"
                           class="btn ml-1 mr-1 btn-primary-grad custom-btn"
                           @click.prevent="scroll('jobs')"
                        >
                           <span>{{ cta.header }}</span>
                        </a>
                     </span>
                  </div>
               </div>
            </div>
         </div>
         <div class="banner-img">
            <div class="bg-container" />
            <img
               v-lazy-image
               src=""
               :data-src="landingBoxData.bannerImages[0].src"
               :alt="landingBoxData.bannerImages[0].alt"
            />
         </div>
      </div>
      <div class="middle-box py-8">
         <div class="container container-1200">
            <div class="row">
               <div class="col-12 pb-6 text-center header-text">
                  <h2>{{ middleBoxData.header }}</h2>
                  <p>{{ descriptionJoiner(middleBoxData.shortDescription) }}</p>
               </div>
            </div>
            <div class="row no-gutters ">
               <div
                  v-for="(card, index) in middleBoxData.cards"
                  :key="index"
                  class="col-lg-4 col-md-6 col-sm-6 col-xs-12 custom-card d-flex align-items-center"
               >
                  <div class="data-container">
                     <img
                        v-if="card.type === 'image'"
                        class="data-container-image"
                        :src="card.src"
                     />
                     <div
                        v-if="card.type === 'content'"
                        class="data-container-content  pt-4 pb-4 pt-sm-0 pb-sm-0 "
                     >
                        <h4>{{ card.header }}</h4>
                        <p class="mb-0">{{ descriptionJoiner(card.shortDescription) }}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div id="jobs" class="passion-box pt-8 pb-6">
         <div class="container container-1200">
            <div class="row">
               <div class="col-12 pb-6 text-center header-text">
                  <h2>{{ passionBoxData.header }}</h2>
                  <p>{{ descriptionJoiner(passionBoxData.shortDescription) }}</p>
               </div>
            </div>
            <div class="row mb-2">
               <div
                  v-for="(card, index) in passionBoxData.cards"
                  :key="index"
                  class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4"
               >
                  <div class="card shadow card-bordered card-hover">
                     <div class="card-header">
                        <span
                           :class="[
                              'badge badge-primary',
                              jobs[card.department.toLowerCase()].class,
                              'text-white',
                           ]"
                           >{{ card.department }}</span
                        >
                     </div>
                     <div class="card-body">
                        <span class="icon-container">
                           <i :class="jobs[card.department.toLowerCase()].icon" />
                        </span>
                     </div>
                     <div class="card-footer pt-0">
                        <h5>{{ card.header }}</h5>
                        <p>{{ card.shortDescription }}</p>
                        <a
                           class="job-link"
                           :href="card.link"
                           target="_blank"
                           rel="noopener noreferrer"
                           :title="card.header"
                           ><span>SEE JOB <i class="fc_keyboard_arrow_right"/></span
                        ></a>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-12 text-center">
                  <p class="mb-0">
                     Can't find your interest, but think you're a good fit?
                     <a class="mailto" @click.prevent="mailTo">Talk to us!</a>
                  </p>
               </div>
            </div>
         </div>
      </div>
      <div class="testimonial-box pt-8 pb-9">
         <div class="container container-1440">
            <div class="row">
               <div class="col-12 pb-2 text-center header-text">
                  <h2>{{ testimonialBoxData.header }}</h2>
                  <span>{{ descriptionJoiner(testimonialBoxData.shortDescription) }}</span>
               </div>
            </div>
            <div class="row">
               <div class="col-12">
                  <testimonialSlider :testimonies="testimonialBoxData.cards" />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../util/meta.js';
import testimonialSlider from '../components/career/Testimonial';

export default {
   name: 'Careers',
   metaInfo() {
      return metaGenerator(this.careersPageData);
   },
   components: { testimonialSlider },
   data() {
      return {
         isDomChanged: false,
         subject: '',
         body: 'Contact FusionCharts | (Enter your reason for getting in touch)',
         jobs: {
            'customer success': {
               icon: 'fc_headset_mic',
               class: 'customer_success',
            },
            engineering: {
               icon: 'fc_code',
               class: 'engineering',
            },
            marketing: {
               icon: 'fc_bullhorn',
               class: 'marketing',
            },
            qa: {
               icon: 'fc_monitor_process',
               class: 'qa',
            },
            design: {
               icon: 'fc_pen_tool',
               class: 'design',
            },
            sales: {
               icon: 'fc_performance_charts',
               class: 'sales',
            },
            content: {
               icon: 'fc_edit',
               class: 'content',
            },
            operations: {
               icon: 'fc_cog_wheel',
               class: 'operations',
            },
            account: {
               icon: 'fc_cost_monitor',
               class: 'account',
            },
            business: {
               icon: 'fc_suit',
               class: 'business',
            },
            product: {
               icon: 'fc_product',
               class: 'product',
            },
         },
      };
   },
   asyncData({ store }) {
      return Promise.all([store.dispatch('CAREERS_PAGE_DATA_FETCH')]);
   },
   mounted() {
      this.isClient = true;
      this.srceenSize = this.$mq;
      this.swapCards();
   },
   computed: {
      ...mapState(['careersPageData']),

      landingBoxData() {
         return this.careersPageData.landingBoxData;
      },
      middleBoxData() {
         return this.careersPageData.middleBoxData;
      },
      passionBoxData() {
         return this.careersPageData.passionBoxData;
      },
      testimonialBoxData() {
         return this.careersPageData.testimonialBoxData;
      },
   },
   methods: {
      goto(e, url) {
         this.$router.push(url).catch(() => {});
      },

      scroll(id) {
         const val = document.getElementById(id).offsetTop + 20;
         val && fusionDesign.scroll.to(val, 1200, 'easeInOutExpo');
      },

      mailTo() {
         window.location.href = `mailto:hello@fusioncharts.com?subject=${this.subject}&body=${this.body}`;
      },

      swapCards() {
         const list = document.getElementsByClassName('custom-card');
         const signal = this.srceenSize === 'md' || this.srceenSize === 'sm';
         const swapNodes = (a, b) => {
            const aparent = a.parentNode;
            const asibling = a.nextSibling === b ? a : a.nextSibling;
            b.parentNode.insertBefore(a, b);
            aparent.insertBefore(b, asibling);
         };
         const traverser = () => {
            for (let c = 2, cc = list.length; c < cc; c += 4) {
               const a = list[c];
               const b = a.nextSibling;
               if (a && b) swapNodes(a, b);
            }
         };

         if (signal && !this.isDomChanged) {
            traverser();
            this.isDomChanged = true;
         } else if (!signal && this.isDomChanged === true) {
            traverser();
            this.isDomChanged = false;
         }
      },
   },

   watch: {
      $mq() {
         this.$nextTick(() => {
            this.srceenSize = this.$mq;
            this.swapCards();
         });
      },
   },
};
</script>

<style lang="scss">
.careers {
   .header-text {
      h2 {
         color: #212344;
         font-size: 29px;
         letter-spacing: 0.45px;
         margin-bottom: 0.5rem;
      }
      p {
         color: #434456;
         font-size: 16px;
         line-height: 28px;
      }
   }

   .landing-box {
      position: relative;
      overflow: hidden;

      .banner-img,
      .bg-container {
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
      }

      .banner-img {
         z-index: 1;
         img {
            width: 100%;
         }
         @media (max-width: 800px) {
            img {
               display: none;
            }
         }
      }

      .bg-container {
         z-index: 2;
         background: linear-gradient(135deg, #060a27 0%, #28193f 100%);
         opacity: 0.9;
      }

      .landing-box-data {
         padding: 121px 0;
         z-index: 3;

         p {
            color: #efefef;
            font-size: 19px;
            opacity: 0.8;
            line-height: 24px;
         }

         .btn {
            padding: 1.3rem 2.4rem;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: 0.2px;
            line-height: 16px;
            text-decoration: none;
         }
      }
   }

   .middle-box {
      .custom-card {
         background-color: #f9f9fb;
         .data-container {
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            margin: 0 auto;

            &-image {
               flex-shrink: 0;
               // min-width: 100%;
               // min-height: 100%;
               width: 100%;
               height: auto;
            }
            &-content {
               padding: 0 25px;
               text-align: center;
               h4 {
                  color: #212344;
                  font-size: 19px;
                  font-weight: 600;
                  line-height: 24px;
               }
               p {
                  color: #686980;
                  font-size: 16px;
                  line-height: 28px;
               }
            }
         }
      }
   }

   .passion-box {
      background-color: #f8f9fd;
      .mailto {
         color: #5648d4;
         font-size: 16px;
         font-weight: 600;
         cursor: pointer;
      }
      .card {
         .card-header {
            .badge {
               top: 1.6rem;
               right: 1.6rem;
            }
         }
         .card-body {
            align-self: center;
            padding-bottom: 2.8rem;
            span {
               display: block;
               width: 100px;
               height: 100px;
               background-color: #f3f7fb;
               text-align: center;

               i {
                  font-size: 40px;
                  line-height: 100px;
               }
            }
         }
         .card-footer {
            text-align: center;
            position: relative;
            h5 {
               color: #212344;
               font-size: 16px;
               font-weight: 600;
               letter-spacing: 0.23px;
               line-height: 20px;
            }

            p {
               color: #686980;
               font-size: 14px;
               letter-spacing: 0.23px;
               line-height: 24px;
            }

            .job-link {
               display: block;
               position: absolute;
               bottom: 0;
               left: 0;
               height: auto;
               padding: 30px 0 0;
               width: 100%;
               text-decoration: none;
               background: linear-gradient(
                  180deg,
                  rgba(248, 250, 253, 0) 0%,
                  rgba(253, 253, 254, 0.96) 27.32%,
                  #ffffff 100%
               );
               opacity: 0;
               transition: all 0.5s linear;

               cursor: default;
               span {
                  cursor: pointer;
                  color: #5648d4;
                  font-size: 14px;
                  font-weight: 600;
                  line-height: 1;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  i {
                     font-size: 20px;
                  }
               }
            }
         }

         &:hover {
            .job-link {
               opacity: 1;
               transform: translateY(-25px);
            }
         }
      }

      .customer_success {
         background-color: #48b884;
      }
      .marketing {
         background-color: #8779e1;
      }
      .product {
         background-color: #e1a434;
      }
      .business {
         background-color: #434456;
      }
      .account {
         background-color: #6dc69d;
      }
      .operations {
         background-color: #16d3c0;
      }
      .content {
         background-color: #36a3cb;
      }
      .sales {
         background-color: #8786a4;
      }
      .design {
         background-color: #6957da;
      }
      .qa {
         background-color: #f68a57;
      }
      .engineering {
         background-color: #43ccfe;
      }
   }
}
</style>
